export default {
  path: 'after-register',
  name: 'AfterRegister',
  component: () => import(/* webpackChunkName: "AfterRegister" */ '@/app/auth/afterRegister/AfterRegisterContainer.vue'),
  meta: {
    title: 'TV24 | Zarejestrowano',
    public: true,
    onlyWhenLoggedOut: true,
  },
};
